// Shared button and text styles used by more than one component.

import { BODY_FONT } from './palette'

export const primaryBtn = palette => ({
    fontFamily: BODY_FONT,
    fontSize: '13px',
    fontWeight: 500,
    padding: '10px 18px',
    borderRadius: '8px',
    border: 'none',
    background: palette.ink,
    color: palette.panelBg,
    cursor: 'pointer',
})

export const secondaryBtn = palette => ({
    fontFamily: BODY_FONT,
    fontSize: '13px',
    fontWeight: 500,
    padding: '10px 16px',
    borderRadius: '8px',
    border: `1px solid ${palette.line}`,
    background: 'transparent',
    color: palette.ink,
    cursor: 'pointer',
})

export const dangerBtn = palette => ({
    fontFamily: BODY_FONT,
    fontSize: '13px',
    fontWeight: 500,
    padding: '10px 16px',
    borderRadius: '8px',
    border: `1px solid ${palette.line}`,
    background: 'transparent',
    color: `oklch(50% 0.15 ${palette.negHue})`,
    cursor: 'pointer',
})

export const toggleBtn = (selected, palette, tight) => ({
    fontFamily: BODY_FONT,
    fontSize: '13px',
    fontWeight: 500,
    padding: tight ? '8px 10px' : '9px 14px',
    borderRadius: '8px',
    border: `1px solid ${selected ? palette.ink : palette.line}`,
    background: selected ? palette.ink : 'transparent',
    color: selected ? palette.panelBg : palette.ink,
    cursor: 'pointer',
})
